// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13CSJ","left":"styles_left__2mMuQ","desktopActions":"styles_desktopActions__anLA_","title":"styles_title__1XPar"};